import { render } from "./shareCodeDetail.vue?vue&type=template&id=e0f4d5ec&scoped=true"
import script from "./shareCodeDetail.vue?vue&type=script&lang=js"
export * from "./shareCodeDetail.vue?vue&type=script&lang=js"

import "./shareCodeDetail.vue?vue&type=style&index=0&id=e0f4d5ec&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0f4d5ec"],['__file',"src/views/channel/components/shareCodeDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e0f4d5ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e0f4d5ec', __exports__)) {
    console.log('reload')
    api.reload('e0f4d5ec', __exports__)
  }
  
  module.hot.accept("./shareCodeDetail.vue?vue&type=template&id=e0f4d5ec&scoped=true", () => {
    console.log('re-render')
    api.rerender('e0f4d5ec', render)
  })

}


export default __exports__